/**
 * Cross-portal appearance handoff (host app → linked form app).
 * Query names are part of the wire contract; keep in sync with the form app `appearanceQueryConstants`.
 */
export const PORTAL_APPEARANCE_THEME_QUERY = 'portalTheme';
export const PORTAL_APPEARANCE_ACCENT_QUERY = 'portalAccent';
